import { Space, TableProps } from "antd";
import { Link } from "react-router-dom";
import { PaymentStatus } from "../../../enum/lisence";
import { DataType } from "../../../models/interface/license.interface";

export const Columns: TableProps<DataType>["columns"] = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "カメラシリアルナンバー",
    dataIndex: "cameraSerial",
    key: "cameraSerial",
  },
  {
    title: "HWシリアルナンバー",
    dataIndex: "hwSerial",
    key: "hwSerial",
  },
  {
    title: "有効期限",
    dataIndex: "expiresAt",
    key: "expiresAt",
    render: (_, { expiresAt }) => <span>{expiresAt?.split("T")[0]}</span>,
  },
  {
    title: "Agent Name",
    dataIndex: "assignedAgent",
    key: "assignedAgent",
  },
  {
    title: "購入日",
    dataIndex: "activatedAt",
    key: "activatedAt",
    render: (_, { activatedAt }) => <span>{activatedAt?.split("T")[0]}</span>,
  },
  {
    title: "ステータス",
    dataIndex: "status",
    key: "status",
    render: (_, { batch }) => {
      if (batch.paymentStatus === PaymentStatus.PAID) {
        return (
          <div className="rounded-md w-[86px] h-[26px] bg-[#77BF4033] text-center">
            <p className="text-sm font-normal text-[#098906] mb-0 leading-[26px]">
              支払い済み
            </p>
          </div>
        );
      }
      if (batch.paymentStatus === PaymentStatus.UNPAID) {
        return (
          <div className="rounded-md w-[86px] h-[26px] bg-[#FFA90933] text-center">
            <p className="text-sm font-normal text-[#FF8B01] mb-0 leading-[26px]">
              未払い
            </p>
          </div>
        );
      }
      return (
        <div className="rounded-md w-[86px] h-[26px] bg-[#FF978B33] text-center">
          <p className="text-sm font-normal text-[#FF5646] mb-0 leading-[26px]">
            キャンセル
          </p>
        </div>
      );
    },
  },
  {
    title: "アクション",
    key: "action",
    render: (_, record) => (
      <Space size="middle">
        <Link
          to={`/admin/license-management/${record.id}`}
          className="base-button w-[75px] h-[41px] rounded  flex justify-center items-center"
        >
          詳細
        </Link>
      </Space>
    ),
  },
];
